import { useState } from "react";
import Grid from "@material-ui/core/Grid";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleOutlinedIcon from "@material-ui/icons/RemoveCircleOutlined";
import { Divider, Typography, Button, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
let lastElementId = 1000;
const IncomePerYearComponent = (props) => {
  const {
    inputValue,
    handleCustomSubmit,
    rowState,
    cell,
    handleClose: handleClosePopup,
  } = props;

  const { id, customComponentKey } = cell.column.columnDef;

  const { dropdowns } = rowState;

  const modifiedInputValue = inputValue?.map((el, ind) => {
    if (ind === inputValue.length - 1) {
      lastElementId = ind + lastElementId;
    }
    return { ...el, elementId: ind + lastElementId };
  });
  const emptyInputValue = [
    {
      elementId: 1000,
      income: "",
      currency_id: "",
      year: "",
    },
  ];
  const [incomePerYear, setIncomePerYear] = useState(
    modifiedInputValue || emptyInputValue
  );

  const removeExistingIncome = (incomePosition) => {
    setIncomePerYear((prev) => {
      console.log(
        "removing ",
        incomePosition,
        prev.filter((el, ind) => ind !== incomePosition)
      );
      return prev.filter((el, ind) => ind !== incomePosition);
    });
  };

  const handleAddNewIncome = () => {
    const newCall = {
      income: "",
      currency_id: "",
      year: "",
    };
    lastElementId = lastElementId + 1;
    setIncomePerYear((prev) => {
      return [...prev, { ...newCall, elementId: lastElementId }];
    });
  };

  const handleIncomeChange = (event) => {
    console.log(event, "dataset");
    const incomePosition = event.target.dataset["position"];
    setIncomePerYear((prev) => {
      const oldIncomes = [...prev];
      oldIncomes[incomePosition] = {
        ...oldIncomes[incomePosition],
        [event.target.dataset.id]: event.target.value,
      };
      return oldIncomes;
    });
  };

  const currencyDropdownOptions = dropdowns["currencies"] || [];

  const handleSubmit = () => {
    const postValue = incomePerYear.map((el) => {
      const postObj = {
        income: el.income,
        currency_id: el.currency_id,
        year: el.year,
      };
      if (el.id) {
        postObj.id = el.id;
      }
      return postObj;
    });
    handleCustomSubmit(id, postValue, customComponentKey);
    handleClosePopup();
  };
  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        flexDirection: "column",
        alignItems: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "0.5rem",
          marginBottom: "1rem",
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          style={{ fontSize: "16px", fontWeight: "bold" }}
        >
          Income per year
        </Typography>

        <AddCircleIcon
          type="submit"
          onClick={() => handleAddNewIncome()}
          fontSize="large"
          color="primary"
          style={{ cursor: "pointer" }}
        />
      </div>
      <div style={{ width: "100%", flexGrow: 1 }}>
        {incomePerYear?.map((item, index) => {
          return (
            <>
              <Grid container spacing={1} key={item.elementId}>
                <Grid item xs={4}>
                  <input
                    className="live-view-custom-input-component"
                    type="number"
                    defaultValue={Number(item.income)}
                    inputValue={Number(item.income)}
                    placeholder="$00,000,000"
                    onChange={handleIncomeChange}
                    data-position={index}
                    data-id="income"
                    id={"income_" + item.elementId}
                    title="Please input numbers only"
                    pattern="[0-9]+"
                  />
                </Grid>
                <Grid item xs={3}>
                  <Autocomplete
                    id={"currency_id_" + item.elementId}
                    ListboxProps={{
                      style: {
                        fontSize: "12px",
                      },
                    }}
                    autoComplete
                    disableClearable
                    options={[...(currencyDropdownOptions || [])]}
                    placeholder="USD"
                    onChange={(event, selected) => {
                      setIncomePerYear((prev) => {
                        const oldIncomes = [...prev];
                        oldIncomes[index] = {
                          ...oldIncomes[index],
                          currency_id: selected?.id || -1,
                        };
                        return oldIncomes;
                      });
                    }}
                    getOptionLabel={(option) => option?.value}
                    style={{ width: "100%" }}
                    value={currencyDropdownOptions.find(
                      (el) => el.id === item.currency_id
                    )}
                    defaultValue={currencyDropdownOptions.find(
                      (el) => el.id === item.currency_id
                    )}
                    renderInput={(params) => {
                      const { inputProps, InputProps, ...otherParams } = params;
                      inputProps.style = {
                        fontSize: "12px",
                      };
                      return (
                        <TextField
                          {...otherParams}
                          InputProps={InputProps}
                          inputProps={inputProps}
                          fullWidth
                          variant="outlined"
                        />
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={3} style={{ padding: "4px" }}>
                  <input
                    className="live-view-custom-input-component"
                    type="text"
                    defaultValue={item.year}
                    inputValue={item.year}
                    maxLength={4}
                    data-position={index}
                    placeholder="Year"
                    onChange={handleIncomeChange}
                    data-id="year"
                    id={"year_" + item.elementId}
                  />
                </Grid>
                <Grid item xs={1}>
                  {incomePerYear.length > 1 ? (
                    <RemoveCircleOutlinedIcon
                      type={"submit"}
                      fontSize="large"
                      onClick={() => removeExistingIncome(index)}
                      style={{
                        cursor: "pointer",
                        color: "red",
                      }}
                    />
                  ) : null}
                </Grid>
              </Grid>
              {index === incomePerYear.length - 1 && <Divider />}
            </>
          );
        })}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "0.5rem",
          marginBottom: "1rem",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ textTransform: "none" }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default IncomePerYearComponent;
